interface Props {
  iconName: string
  size?: 'tiny' | 'small' | 'medium' | 'large'
  title?: string
  className?: string
  category?: number
}

const BlizzardIcon = ({ iconName, size, title, className }: Props) => {
  const sizeStyles = {
    tiny: 'w-3 h-3 border-0 min-w-3 min-h-3',
    small: 'w-4 h-4 border-0 min-w-4 min-h-4',
    medium: 'w-6 h-6 border min-w-6 min-h-6',
    large: 'w-8 h-8 border-2 min-w-8 min-h-8',
  }[size ?? 'medium']

  const iconStyles = `${sizeStyles} border-[#666] rounded-md ${className ?? ''}`

  return (
    <img
      className={iconStyles}
      title={title}
      alt={title}
      src={`https://wow.zamimg.com/images/wow/icons/large/${iconName}.jpg`}
    />
  )
}

export default BlizzardIcon
